import { render, staticRenderFns } from "./StudentsList.vue?vue&type=template&id=01c6394c&"
import script from "./StudentsList.vue?vue&type=script&lang=ts&"
export * from "./StudentsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports